import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class CgmEnderecoResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  all(cgmId) {
    return this.http.get(this.resource, {
      params: {
        cmg_id: cgmId,
      },
    });
  }

  checkPrincipal(id) {
    return this.http.put(`${this.resource}/${id}/check_principal`);
  }
}

const resource = 'cgm_endereco';

const moduleHttp = new CgmEnderecoResourceHttp(clientHttp, prefixBase + resource);

export default moduleHttp;
